import React, { useState, useEffect } from 'react';

const Footer = () => {
  const [frienderLink, setFrienderLink] = useState(null);
  const [frienderText, setFrienderText] = useState(null);
  const [clickHereLink, setClickHereLink] = useState(null);
  const [clickHereText, setClickHereText] = useState(null);
  const [extensionID, setextensionId] = useState("");
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const gmuserItem = localStorage.getItem('_gm_usr');
    const gmuser = gmuserItem ? JSON.parse(gmuserItem) : false;
    const gmExtensionId = localStorage.getItem('_gm_extId');
    if (gmuser) {
      setUserEmail(gmuser.gmUsrEmail);
    }
    if (gmExtensionId) {
      setextensionId(gmExtensionId)
    }
  }, []);

  const frienderInfo = () => {
    fetch("https://app.kyubi.io/api/end-user/get-links/", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify({
        email: userEmail,
        ext_id: extensionID,
      }),
    })
      .then(async (response) => response.json())
      .then(async (res) => {
        const resp = res.data ? res.data : res;
        if (res.status == true) {
          // console.log("response", resp);

          setFrienderLink(resp.links[0].link);
          setFrienderText(resp.links[0].title);
          setClickHereText(resp.links[1].title);
          setClickHereLink(resp.links[1].link);
        }
      });
  };

  useEffect(() => {
    if (extensionID === "60b914cf9db9ad625ad4cadf" && userEmail) {
      frienderInfo();
    }
  }, [userEmail, extensionID]);

  return (
    <div className='footerSection'>
      <p className='footerText'>
        Powered by <a href="https://tier5.in" target="_blank">Tier5</a>
        {extensionID === "60b914cf9db9ad625ad4cadf" ? <span className="footerGap">|</span> : ""}
      </p>
      {extensionID === "60b914cf9db9ad625ad4cadf" ?
        <p className='footerInfo'>An even more powerful software <a id="" href={frienderLink} target="_blank">{frienderText}</a> is coming soon. Click <a id="" href={clickHereLink} target="_blank">{clickHereText}</a> for more information</p>
        : ""}
    </div>
  );
};

export default Footer;
